import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const linkClass = (path: string) =>
    `text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
      location.pathname === path
        ? 'text-primary-600'
        : 'text-foreground-700 hover:text-primary-500'
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-xl font-bold text-foreground-900 whitespace-nowrap">
              调教指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass('/')}>
              首页
            </Link>
            <Link to="/category/pet-training" className={linkClass('/category/pet-training')}>
              宠物调教
            </Link>
            <Link to="/category/skill-training" className={linkClass('/category/skill-training')}>
              技能训练
            </Link>
            <Link to="/category/behavior-modification" className={linkClass('/category/behavior-modification')}>
              行为调教
            </Link>
            <Link to="/category/self-improvement" className={linkClass('/category/self-improvement')}>
              自我提升
            </Link>
            <Link to="/about" className={linkClass('/about')}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              获取咨询
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="flex flex-col px-4 py-4 gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              首页
            </Link>
            <Link to="/category/pet-training" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              宠物调教
            </Link>
            <Link to="/category/skill-training" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              技能训练
            </Link>
            <Link to="/category/behavior-modification" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              行为调教
            </Link>
            <Link to="/category/self-improvement" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              自我提升
            </Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">
              关于我们
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap text-center px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              获取咨询
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}